import {
    RESET_SWING,
    GET_SWING_LIST,
    GET_SWING_LIST_SUCCESS,
    GET_SWING_LIST_ERROR
} from '../constants/ActionTypes';

const INIT_SWING_STATE = {
    playerUid: "",
    sessionId: "",
    swingList: [],
    swingListLoader: false,
    swingListError: null
}

export default (state = INIT_SWING_STATE, action) => {
    switch (action.type) {
        case RESET_SWING: {
            return {
                ...INIT_SWING_STATE
            }
        }
        case GET_SWING_LIST: {
            return {
                ...state,
                swingListLoader: true,
                sessionId: action.payload.sessionId,
                playerUid: action.payload.playerUid
            }
        }
        case GET_SWING_LIST_SUCCESS: {
            return {
                ...state,
                swingList: action.payload,
                swingListLoader: false,
                swingListError: null
            }
        }
        case GET_SWING_LIST_ERROR: {
            return {
                ...state,
                swingListError: action.payload,
                swingListLoader: false
            }
        }
        default:
            return state;
    }
}